<script setup lang="ts">
useSeoMeta({
  title: "Términos legales de uso · Selectalent Formaciones",
  description: "Condiciones de uso del sitio web de Selectalent Formaciones.",
  ogTitle: "Términos legales de uso · Selectalent Formaciones",
  ogDescription: "Condiciones de uso del sitio web de Selectalent Formaciones.",
  twitterCard: "summary_large_image",
});
</script>

<template>
  <main>
    <section class="mx-auto max-w-3xl px-6 py-12 md:py-16 space-y-12">
      <!-- Encabezado -->
      <header>
        <h1
          class="font-poppins text-3xl md:text-5xl font-black leading-tight text-softblack"
        >
          TÉRMINOS LEGALES DE USO
        </h1>
        <p class="mt-3 font-opensans text-sm text-neutral-600">
          Condiciones de uso
        </p>
      </header>

      <!-- Condiciones -->
      <article class="space-y-6">
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Las presentes condiciones regulan el uso del sitio web donde se
          facilita al público general información relativa a los servicios de
          Selectalent Formaciones. El hecho de acceder a este sitio web y
          utilizar los materiales contenidos en ella implica que usted ha leído
          y acepta, sin reserva alguna, estas condiciones. Selectalent
          Formaciones se reserva el derecho de denegar, suspender, interrumpir o
          cancelar el acceso o la utilización, total o parcialmente, de este
          sitio web a aquellos usuarios o visitantes del mismo que incumplan
          cualquiera de las condiciones previstas en este Aviso Legal.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Este sitio web contiene materiales, como artículos, estudios,
          descripción de proyectos, preparados por Selectalent Formaciones con
          fines únicamente informativos. Selectalent Formaciones le informa que
          estos materiales pueden ser modificados, desarrollados o actualizados
          en cualquier momento sin notificación previa.
        </p>
      </article>

      <div class="h-px w-full bg-neutral-200"></div>

      <!-- Derechos de Propiedad -->
      <article class="space-y-6">
        <h2 class="font-poppins text-2xl font-black text-softblack">
          Derechos de Propiedad Intelectual e Industrial
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          La totalidad del contenido de este sitio web [...] está protegido por
          derechos de propiedad industrial e intelectual, titularidad de
          Selectalent Formaciones o de terceros, sin que puedan entenderse
          cedidos los derechos de explotación sobre los mismos más allá de lo
          estrictamente necesario para el correcto uso del sitio web.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          En particular, quedan prohibidas la reproducción, la transformación,
          distribución, comunicación pública [...] salvo autorización expresa de
          Selectalent Formaciones.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Queda asimismo prohibido descompilar, desensamblar, realizar
          ingeniería inversa [...] así como manipular cualquier sistema de
          seguridad que pueda estar instalado en el mismo.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Las marcas, nombres comerciales o signos distintivos son titularidad
          de Selectalent Formaciones o de terceros, sin que pueda entenderse que
          el acceso al sitio web atribuya ningún derecho sobre las citadas
          marcas.
        </p>
      </article>

      <div class="h-px w-full bg-neutral-200"></div>

      <!-- Enlaces -->
      <article class="space-y-6">
        <h2 class="font-poppins text-2xl font-black text-softblack">Enlaces</h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Los hiperenlaces o links que contiene este sitio web pueden conducir
          al usuario a otros sitios web gestionados por terceros, sobre los que
          Selectalent Formaciones no ejerce ningún tipo de control. Selectalent
          Formaciones no responde ni de los contenidos ni del estado de dichos
          sitios y páginas web.
        </p>
      </article>

      <div class="h-px w-full bg-neutral-200"></div>

      <!-- Cambios -->
      <article class="space-y-6">
        <h2 class="font-poppins text-2xl font-black text-softblack">
          Cambios y disponibilidad
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Con el fin de mejorar el sitio web, Selectalent Formaciones se reserva
          el derecho, en cualquier momento y sin previa notificación, a
          modificar, ampliar o suspender temporalmente la presentación,
          configuración, especificaciones técnicas y servicios del sitio web, de
          forma unilateral. Asimismo, se reserva el derecho de modificar en
          cualquier momento las presentes condiciones de uso.
        </p>
      </article>

      <div class="h-px w-full bg-neutral-200"></div>

      <!-- Limitación -->
      <article class="space-y-6">
        <h2 class="font-poppins text-2xl font-black text-softblack">
          Liberación y limitación de responsabilidad
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Este sitio Web contiene únicamente información general, y no se provee
          de ningún tipo de asesoría o servicios profesionales. El uso de este
          sitio Web es bajo su propio riesgo [...]
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Selectalent Formaciones, sus socios, colaboradores, empleados y
          representantes no se responsabilizan de los errores u omisiones que
          pudieran contener los contenidos de este sitio web. Tampoco podrán ser
          considerados responsables por daños derivados de la utilización de
          este sitio web.
        </p>
      </article>

      <div class="h-px w-full bg-neutral-200"></div>

      <!-- Comunicación ilícita -->
      <article class="space-y-6">
        <h2 class="font-poppins text-2xl font-black text-softblack">
          Comunicación de actividades ilícitas e inadecuadas
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          En el caso de que cualquier usuario tuviera conocimiento de que los
          hiperenlaces remiten a páginas con contenidos ilícitos, nocivos o
          contrarios a la moral podrá ponerse en contacto con Selectalent
          Formaciones indicando sus datos personales y la descripción de los
          hechos.
        </p>
      </article>

      <div class="h-px w-full bg-neutral-200"></div>

      <!-- Legislación -->
      <article class="space-y-6">
        <h2 class="font-poppins text-2xl font-black text-softblack">
          Legislación
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Las presentes condiciones de uso se rigen en todos y cada uno de sus
          extremos por la legislación española.
        </p>
      </article>

      <!-- Footer -->
      <footer class="pt-10">
        <p class="font-opensans text-sm text-neutral-600">
          © Selectalent Formaciones
        </p>
      </footer>
    </section>
  </main>
</template>
